// @flow
import React from 'react'

// components
import { Popover } from '../../Components/'
import { Bool } from '../_formFields'

const EquipmentMiniApp = (props) => {
  const { miniAppData, content } = props
  const { discounts, setDiscounts, inputHelps } = miniAppData

  const handleOnChange = (name: string, value: boolean) => {
    setDiscounts(discounts.setIn(['CarPillow', 'equipment', name], value))
  }

  return (
    <div className="col-12 mt-5 mb-4 p-0">
      <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-top checkboxAssociationTwoColumns-group">
        <div className="w-100">
          <div className="col-12">
            <label className="mb-0 mr-4 font-weight-bold">Výbava vozidla</label>
          </div>
          <div className="col-6 mt-4 mb-4 p-0" key="discountCheckboxes">
            <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center" key="drive4x4-content">
              <div className="col-12 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0">
                <Bool
                  enabled
                  id="drive4x4"
                  isPristine
                  label={content.fieldNames.drive4x4 || 'drive4x4'}
                  name="drive4x4"
                  onChange={(value) => {
                    handleOnChange('drive4x4', value)
                  }}
                  prefix="pillow-"
                  validationErrors={{}}
                  value={discounts.getIn(['CarPillow', 'equipment', 'drive4x4'], false)}
                />
              </div>
              <div className="col-2 col-sm-3 order-0 order-sm-0 text-right">
                {inputHelps &&
                  inputHelps.drive4x4 &&
                  inputHelps.drive4x4.content && (
                    <Popover
                      content={inputHelps.drive4x4.content}
                      id="IDdrive4x4"
                      title={inputHelps.drive4x4.title}
                    />
                  )}
              </div>
            </div>
            <div
              className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center"
              key="parkingAssistant-content"
            >
              <div className="col-12 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0">
                <Bool
                  enabled
                  id="parkingAssistant"
                  isPristine
                  label={content.fieldNames.parkingAssistant || 'parkingAssistant'}
                  name="parkingAssistant"
                  onChange={(value) => {
                    handleOnChange('parkingAssistant', value)
                  }}
                  prefix="pillow-"
                  validationErrors={{}}
                  value={discounts.getIn(['CarPillow', 'equipment', 'parkingAssistant'], false)}
                />
              </div>
              <div className="col-2 col-sm-3 order-0 order-sm-0 text-right">
                {inputHelps &&
                  inputHelps.parkingAssistant &&
                  inputHelps.parkingAssistant.content && (
                    <Popover
                      content={inputHelps.parkingAssistant.content}
                      id="IDparkingAssistant"
                      title={inputHelps.parkingAssistant.title}
                    />
                  )}
              </div>
            </div>
            <div
              className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center"
              key="automaticTransmission-content"
            >
              <div className="col-12 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0">
                <Bool
                  enabled
                  id="automaticTransmission"
                  isPristine
                  label={content.fieldNames.automaticTransmission || 'automaticTransmission'}
                  name="automaticTransmission"
                  onChange={(value) => {
                    handleOnChange('automaticTransmission', value)
                  }}
                  prefix="pillow-"
                  validationErrors={{}}
                  value={discounts.getIn(['CarPillow', 'equipment', 'automaticTransmission'], false)}
                />
              </div>
              <div className="col-2 col-sm-3 order-0 order-sm-0 text-right">
                {inputHelps &&
                  inputHelps.automaticTransmission &&
                  inputHelps.automaticTransmission.content && (
                    <Popover
                      content={inputHelps.automaticTransmission.content}
                      id="IDautomaticTransmission"
                      title={inputHelps.automaticTransmission.title}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EquipmentMiniApp
